import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
import _variables from '@/styles/variables.scss';
import themeWhite from '@/styles/themeWhite.scss';
export default {
  components: {
    SidebarItem: SidebarItem,
    Logo: Logo
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar'])), {}, {
    routes: function routes() {
      return this.$router.options.routes;
    },
    activeMenu: function activeMenu() {
      // if(this.$store.state.settings.index){
      //   return "HOME"
      // }
      // if(!sessionStorage.getItem("defaultactivemenu")){
      //   return "HOME"
      // }
      // return sessionStorage.getItem("defaultactivemenu");

      return this.$store.state.settings.index;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      if (this.$store.state.settings.layoutColor && this.$store.state.settings.layoutColor === '白色') {
        return themeWhite;
      }
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    },
    getMenuArr: function getMenuArr() {
      return this.$store.state.settings.menuArr;
    } //  getopenMenuArr(){
    //    let defaulmean = sessionStorage.getItem('defaultmeamarr');
    //    if(defaulmean){
    //      return defaulmean.split(",");
    //    }else{
    //      return [];
    //    }
    // }
  }),
  data: function data() {
    return {
      menuList: [],
      getopenMenuArr: [],
      heightFlag: false
    };
  },
  created: function created() {
    // this.menuData();
  },
  watch: {
    menuList: function menuList(newVal) {
      if (newVal.length > 0) {
        this.heightFlag = true;
      } else {
        this.heightFlag = false;
      }
    }
  },
  methods: {
    handleSelect: function handleSelect() {
      // this.$router.go({
      //       path: keyPath,
      //       force: true
      //     })
    },
    handleOpen: function handleOpen(key, keyPath) {
      if (keyPath.length === 1) {
        this.menuList.push(key);
      }
      this.$store.dispatch('system/setMenuList', keyPath);
      var openmeamrr = sessionStorage.getItem('defaultmeamarr');
      if (openmeamrr) {
        openmeamrr = "".concat(openmeamrr, ",").concat(keyPath);
      } else {
        openmeamrr = "".concat(keyPath);
      }
      sessionStorage.setItem('defaultmeamarr', openmeamrr);
    },
    handleClose: function handleClose(key, keyPath) {
      if (keyPath.length === 1) {
        this.menuList = this.menuList.filter(function (ele) {
          return ele !== key;
        });
      }
      var openmeamrr = sessionStorage.getItem('defaultmeamarr');
      var defultarr = openmeamrr.split(',');
      defultarr.splice(defultarr.indexOf(keyPath[0]), 1);
      sessionStorage.setItem('defaultmeamarr', defultarr);
    } // menuData() {
    //   console.log(this.routes)
    //   this.$API.getMenuInfo({userId: '000000'}).then(res => {
    //     if (res.code === '200') {
    //       // this.menuList = res.result.resourceList
    //       this.$store.dispatch('settings/changeSetting', {
    //         key: 'menuArr',
    //         value: res.result.resourceList
    //       })
    //       this.$store.dispatch('settings/changeSetting', {
    //         key: 'roleTypeArr',
    //         value: res.result.roleList
    //       })
    //     }
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
    // }
  }
};